import { gql } from "@apollo/client";

const HISTORY_LIST_QUERY = gql`
  query history($first: Int, $after: String, $last: Int, $before: String) {
    history(first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          description
          created_on
          updated_on
          published_on
          status
          archived
          created_by {
            name
            email
          }
          published_by {
            name
            email
          }
        }
      }
    }
  }
`;

export { HISTORY_LIST_QUERY };
